import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';

import type { IAppState } from 'shared/common/state';

/**
 * Данные для карусели в полке ЧП.
 */
export const selectEtazhiBlackFridayPromoOffers = (state: IAppState) => {
  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  if (!isEnabled) {
    return null;
  }

  const offers = state.etazhiBlackFriday?.promoOffersData ?? null;

  return offers;
};
